var React = require('react');

function ChevronbigInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M-1.52588e-05 276L99.1343 138L178 138L72.6621 276L-1.52588e-05 276Z","fill":"#FFCD0A","key":0}),React.createElement("path",{"d":"M3.05176e-05 -1.55613e-05L99.1343 138L178 138L72.6621 -3.30596e-06L3.05176e-05 -1.55613e-05Z","fill":"#FFCD0A","key":1})]);
}

ChevronbigInline.defaultProps = {"width":"178","height":"276","viewBox":"0 0 178 276","fill":"none"};

module.exports = ChevronbigInline;

ChevronbigInline.default = ChevronbigInline;
